<template>
  <div id="basketball_recordIndex" v-show="currThemeObj">
    <div class="abs_top">
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
          :colorsArr="selectTab_colorsArr"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_matchInfor"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :curTimeZoneItem="curTimeZoneItem"
        :crossSeason="crossSeason"
        :phaseArr="phaseArr"
        :curPageInitNum="curPageInitNum"
        :isBasketballCupFlag="isBasketballCupFlag"
      ></router-view>
    </div>
  </div>
</template>

<script>
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'basketball_recordIndex',
  components: { selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      crossSeason: true, //是否跨赛季，默认联赛，联赛跨赛季为true，篮球杯赛不跨赛季为false
      isRefresh: false, //是否需要实时更新
      refreshTime: 30 * 1000, //定时器刷的时间 默认
      setIntervalId: null,
      matchPanel_periodsArr: [],
      matchPanel_matchInfor: {
        matchStatus: null,
        homeId: '',
        homeName: '',
        homeScore: '',
        homeLogo: '',
        awayId: '',
        awayName: '',
        awayScore: '',
        awayLogo: '',
      },
      phaseArr_season: [
        {
          phaseId: '0',
          phaseName: '全部',
        },
        {
          phaseId: '1',
          phaseName: '小组赛',
        },
        {
          phaseId: '2',
          phaseName: '淘汰赛',
        },
      ],
      phaseArr: [
        {
          phaseId: '1',
          phaseName: '常规赛',
        },
        {
          phaseId: '2',
          phaseName: '季后赛',
        },
        {
          phaseId: '9',
          phaseName: '保级赛',
        },
      ],
      tabArr: [
        {
          name: '数据概览',
          id: 'dataOverview',
          pathName: 'recordDetailDataOverview',
          act: true,
        },
        {
          name: '球队数据',
          id: 'teamData',
          pathName: 'recordDetailTeamData',
          act: false,
        },
        {
          name: '球员数据',
          id: 'playerData',
          pathName: 'recordDetailPlayerData',
          act: false,
        },
        // {
        //   name: '阵容数据',
        //   id: 'lineupData',
        //   pathName: 'recordDetailLineupData',
        //   act: false,
        // },
      ],
      selectTab_pageJumpParams: [],
      selectTab_colorsArr: null,
      selectTab_colorsKey: [
        'greyColor7',
        'whiteColor',
        'greyColor2',
        'subColor1_1',
      ],
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
    $route(to, from) {
      console.debug('$route:', to, from)
      const arr = to.path.split('/')
      this.onChangeTab({ id: arr[arr.length - 1] })
    },
  },
  computed: {
    isBasketballCupFlag() {
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  created() {
    if (this.currThemeObj) {
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_CBA
      })

      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        //不可点击进入详情
        this.crossSeason = false // 需要传赛季id
        this.phaseArr = this.phaseArr_season
      }
    }
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]
    this.init()
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.dat
      if (this.currThemeObj) {
        this.selectTab_colorsArr = this.selectTab_colorsKey.map((key) => {
          return this.currThemeObj.cssStyle[key]
        })
      }
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      const query = this.$route.query
      this.setIntervalId = setInterval(() => {
        // this.getScheduleDetail(query)
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_recordIndex {
  padding-top: 5.25vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 5.25vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
